import { render } from "./infoForm.vue?vue&type=template&id=87781e50&scoped=true"
import script from "./infoForm.vue?vue&type=script&lang=js"
export * from "./infoForm.vue?vue&type=script&lang=js"

import "./infoForm.vue?vue&type=style&index=0&id=87781e50&lang=scss&scoped=scoped"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87781e50"]])

export default __exports__